/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeModule
 */
export interface StripeModule {
    /**
     * 
     * @type {boolean}
     * @memberof StripeModule
     */
    enabled?: boolean;
    /**
     * Stripe secret API key (encrypted at application level before storage)
     * @type {string}
     * @memberof StripeModule
     */
    api_key?: string;
    /**
     * Stripe webhook signing secret (encrypted at application level)
     * @type {string}
     * @memberof StripeModule
     */
    webhook_secret?: string;
    /**
     * Stripe publishable key (safe for frontend)
     * @type {string}
     * @memberof StripeModule
     */
    public_key?: string;
}

/**
 * Check if a given object implements the StripeModule interface.
 */
export function instanceOfStripeModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StripeModuleFromJSON(json: any): StripeModule {
    return StripeModuleFromJSONTyped(json, false);
}

export function StripeModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'api_key': !exists(json, 'api_key') ? undefined : json['api_key'],
        'webhook_secret': !exists(json, 'webhook_secret') ? undefined : json['webhook_secret'],
        'public_key': !exists(json, 'public_key') ? undefined : json['public_key'],
    };
}

export function StripeModuleToJSON(value?: StripeModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'api_key': value.api_key,
        'webhook_secret': value.webhook_secret,
        'public_key': value.public_key,
    };
}

